module.exports = __webpack_public_path__ + "static/media/firefox-logo.23d7b06c.png";